import { useId } from "react";

// The "INPUT" wordmark, in the style of the app's opening/loading splash
// (components/AnimatedLoader.tsx): heavy weight, wide letter-spacing, with a
// light band that sweeps across the letters (clipped to their shape). Black by
// default.
//
// Canvas is 300×96 with the baseline at 69 (mirroring the native loader);
// the viewBox is cropped to the glyph bounds so `height` maps to the actual
// letter height.
export default function InputMark({
  height = 22,
  color = "#0f1113",
  shine = true,
  className,
}: {
  height?: number;
  color?: string;
  shine?: boolean;
  className?: string;
}) {
  const uid = useId().replace(/:/g, "");
  const clipId = `input-clip-${uid}`;
  const shineId = `input-shine-${uid}`;

  const textProps = {
    x: 150,
    y: 69,
    fontSize: 58,
    fontWeight: 800,
    letterSpacing: 10,
    textAnchor: "middle" as const,
    fontFamily: '"Inter", sans-serif',
  };

  return (
    <svg
      height={height}
      viewBox="34 20 232 56"
      role="img"
      aria-label="Input"
      className={className}
      style={{ display: "block", width: "auto" }}
    >
      <defs>
        <clipPath id={clipId}>
          <text {...textProps}>INPUT</text>
        </clipPath>
        <linearGradient id={shineId} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#ffffff" stopOpacity="0" />
          <stop offset="0.5" stopColor="#ffffff" stopOpacity="0.85" />
          <stop offset="1" stopColor="#ffffff" stopOpacity="0" />
        </linearGradient>
      </defs>

      {/* Base wordmark */}
      <text {...textProps} fill={color}>
        INPUT
      </text>

      {/* Light sweep, clipped to the letter shapes */}
      {shine && (
        <g clipPath={`url(#${clipId})`}>
          <rect
            className="mk-mark-shine"
            x={0}
            y={0}
            width={90}
            height={96}
            fill={`url(#${shineId})`}
          />
        </g>
      )}
    </svg>
  );
}
